import React from "react";
import {useInjection} from "inversify-react";
import {observer} from "mobx-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    HighlightBadge,
    HighlightCardWrapper,
    HighlightGrid,
    HighlightIconWrapper,
    HighlightSection,
    HighlightSubtitle,
    HighlightTextGroup,
    HighlightTitle,
    HighlightTitleRow,
} from "./styled";
import {PlanExtensionCatalogEntity} from "@dropDesk/domain/entities/plan_extensions/plan_extension_catalog.entity";

type Props = {
    extensions: PlanExtensionCatalogEntity[];
}

const ExtensionHighlightCard = observer(({extensions}: Props) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    const highlighted = extensions.filter(e => !!e.highlight && !!e.highlightIcon);
    const isLegacy = appController.user?.company?.newSubs?.isLegacy ?? false;
    const mostSoldSlug = isLegacy ? 'internal_chat' : 'use_app';

    if (highlighted.length === 0) return null;

    return (
        <HighlightSection>
            <HighlightGrid>
                {highlighted.map((extension) => (
                    <HighlightCardWrapper
                        key={extension.id}
                        background={colors.onBackground}
                        border={colors.border}
                    >
                        <HighlightIconWrapper
                            background={`${colors.accent}12`}
                            color={colors.accent}
                            dangerouslySetInnerHTML={{__html: extension.highlightIcon}}
                        />
                        <HighlightTextGroup>
                            <HighlightTitleRow>
                                <HighlightTitle color={colors.text}>{extension.name}</HighlightTitle>
                                {extension.slug === mostSoldSlug && (
                                    <HighlightBadge
                                        background={`${colors.success}18`}
                                        color={colors.success}
                                    >
                                        Mais vendido
                                    </HighlightBadge>
                                )}
                            </HighlightTitleRow>
                            <HighlightSubtitle color={colors.hint}>{extension.highlight}</HighlightSubtitle>
                        </HighlightTextGroup>
                    </HighlightCardWrapper>
                ))}
            </HighlightGrid>
        </HighlightSection>
    );
});

export default ExtensionHighlightCard;
